import { Notify } from "../../utils/notificationManager";

export const FETCH_ALERTS = "FETCH_ALERTS";
export const UPDATE_FETCH_ALERTS = "UPDATE_FETCH_ALERTS";
export const CLEAR_ALERT_LIST = "CLEAR_ALERT_LIST";

export const SILENCE_ALERT = "SILENCE_ALERT";
export const UPDATE_SILENCE_ALERT = "UPDATE_SILENCE_ALERT";

export const UNSILENCE_ALERT = "UNSILENCE_ALERT";
export const UPDATE_UNSILENCE_ALERT = "UPDATE_UNSILENCE_ALERT";

// When fetching the alerts, specify if we should show the page as 'loading'.
// If we show the loading spinner every few seconds this could get annoying
// and kinda defeat the purpose of a quick update!
export function fetchAlerts(limit, offset, silencedFirst, filters) {
  let endpoint = `/alerts?limit=${limit}&offset=${offset}&silencedFirst=${silencedFirst}`;
  if (filters) {
    endpoint = `${endpoint}&alertTypes=${filters}`;
  }

  return {
    type: FETCH_ALERTS,
    meta: {
      endpoint: endpoint,
      success: updateAlerts,
      errorMessage: "Failed to load alerts.",
    },
  };
}

export function updateAlerts(response) {
  return {
    type: UPDATE_FETCH_ALERTS,
    payload: {
      alerts: response.data.alerts,
      alertsPageMeta: response.meta,
    },
  };
}

export function clearAlerts() {
  return {
    type: CLEAR_ALERT_LIST,
  };
}

function getNextAlertState(
  alertUid,
  actionType,
  silencedTimestamp,
  alerts,
  pageMeta,
  showSilenced
) {
  const nextSilenceAlerts = [];
  for (let i in alerts) {
    const alert = alerts[i];
    if (alert.uid === alertUid) {
      if (actionType === SILENCE_ALERT) {
        alert.silencedBy = "you";
        alert.silencedTimestamp = silencedTimestamp;
      } else {
        alert.silencedBy = alert.silencedTimestamp = null;
      }
    }

    if (!showSilenced && alert.silencedBy !== null) {
      // If we're not showing silenced then we should just remove it from the list.
      continue;
    }

    nextSilenceAlerts.push(alert);
  }

  return {
    alerts: nextSilenceAlerts,
    alertsPageMeta: {
      ...pageMeta,
      counts: {
        ...pageMeta.counts,
        silenced: pageMeta.counts.silenced + (actionType === SILENCE_ALERT ? 1 : -1),
        filteredTotal: SILENCE_ALERT
          ? pageMeta.counts.filteredTotal - 1
          : pageMeta.counts.filteredTotal,
      },
    },
  };
}

export function silenceAlert(uid, alerts, pageMeta, userId, showSilenced) {
  return {
    type: SILENCE_ALERT,
    meta: {
      endpoint: `/alerts/${uid}/silence`,
      method: "POST",
      success: updateSilenceAlert,
      errorMessage: "Failed to silence alert.",
    },
    payload: {
      nextState: getNextAlertState(
        uid,
        SILENCE_ALERT,
        Math.floor(Date.now() / 1000),
        alerts,
        pageMeta,
        showSilenced
      ),
    },
  };
}

export function unsilenceAlert(uid, alerts, pageMeta, userId, showSilenced) {
  return {
    type: UNSILENCE_ALERT,
    meta: {
      endpoint: `/alerts/${uid}/unsilence`,
      method: "POST",
      success: updateUnsilenceAlert,
      errorMessage: "Failed to unsilence alert.",
    },
    payload: {
      nextState: getNextAlertState(uid, UNSILENCE_ALERT, null, alerts, pageMeta, showSilenced),
    },
  };
}

export function updateSilenceAlert(response) {
  Notify.success("Alert Silenced", "This alert will not send further notifications");
  return {
    type: UPDATE_SILENCE_ALERT,
  };
}

export function updateUnsilenceAlert(response) {
  Notify.success("Alert Unsilenced", "This alert will send notifications");
  return {
    type: UPDATE_UNSILENCE_ALERT,
  };
}
